import { translate } from "@/lib/metadata"
import { Field } from "@/modules/form/lib/field"
import { Model } from "@/modules/form/lib/model"
import { RequiredRule } from "@/modules/form/rules/required"
import { EmailRule } from "@/modules/form/rules/email"
import { StringRule } from "@/modules/form/rules/string"

export class Contact extends Model {
	// get id(): Field {
	// 	return this.field("id", translate("ID"), this.initData?.id ?? "")
	// }

	get fullname(): Field {
		return this.field("fullname", translate("Full Name"), "")
	}

	get email(): Field {
		return this.field("email", translate("Email"), "")
	}

	get phone_number(): Field {
		return this.field("phone_number", translate("Phone Number"), "")
	}

	get location(): Field {
		return this.field("location", translate("Location"), "")
	}
	get message(): Field {
		return this.field("message", translate("Message"), "")
	}
	get recap(): Field {
		return this.field("recap", translate("Recaptcha"), "")
	}

	get rules(): any[] {
		return [
			[
				[this.fullname, this.email, this.phone_number, this.message],
				StringRule,
			],
			[
				[
					this.fullname,
					this.email,
					this.phone_number,
					this.location,
					this.message,
				],
				RequiredRule,
			],
			[[this.email], EmailRule],
		]
	}
}
